export default __webpack_public_path__ + "aeb8d74672c637adde0d2d95b52a7d38.png";